import type { StopsList } from '@ctcells/api'

/**
 * **전체 E-STOP 판정** — 멈춤 팝업이 E-STOP 모드(「E-STOP 실행 중」 제목 · 붉은 맥박)를 고르는 조건과 작업 줄 머리 「E-STOP」 칩이
 * **같은 판정**을 쓰게 한 곳에 둔다(eric 2026-10-29 「여기에 E-STOP 빨갛게 빨간색으로 표시해야 하는 거 아니야?」).
 *
 * 🔴 두 조건의 AND 다 — ⓐ 걸린 것 목록(`GET /safety/stops`)에 시스템 비상정지 항목(`kind: safety`)이 있다
 *    ⓑ 그 작업의 멈춤 까닭이 `safety_stop` 이다. 안전 상태만으로(`emergency_stop`) 「E-STOP」 이라 하지 않는다 — 팝업과 갈린다.
 * ⚠ 새 판정을 짓지 마라 — 종전 팝업 안의 식(`BatchHaltDialog`)을 그대로 옮겼다.
 */
export function systemSafetyStopOf(stops: StopsList | undefined): boolean {
  return stops?.items.some((item) => item.kind === 'safety') === true
}

/** 그 작업들 중 하나라도 전체 비상정지로 멈췄는가 — `systemSafetyStopOf` ∧ `halt_code === 'safety_stop'` */
export function isGlobalEstop(
  systemSafetyStop: boolean,
  batches: readonly { halt_code?: string | null | undefined }[],
): boolean {
  return systemSafetyStop && batches.some((batch) => batch.halt_code === 'safety_stop')
}
